import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

import MKTypography from "components/MKTypography";
import intro1 from "assets/images/clients/intros/win/win-intro-01.png";
import intro2 from "assets/images/clients/intros/win/win-intro-02.png";
import intro3 from "assets/images/clients/intros/win/win-intro-03.png";

function WindowsDesc() {
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t("clients.windows.desc.title")}
      </MKTypography>

      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro1}
            alt="Windows intro step 1"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.windows.desc.section1Title")}
          </MKTypography>
          <MKTypography variant="body2" color="text">
            {t("clients.windows.desc.section1Body")}
          </MKTypography>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro2}
            alt="Windows intro step 2"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.windows.desc.section2Title")}
          </MKTypography>
          <MKTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
            {t("clients.windows.desc.section2Body")}
          </MKTypography>
          <MKTypography variant="h6" fontWeight="bold" mt={2} mb={0.5}>
            {t("clients.windows.desc.section2RoutingTitle")}
          </MKTypography>
          <MKTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
            {t("clients.windows.desc.section2RoutingBody")}
          </MKTypography>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro3}
            alt="Windows intro step 3"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.windows.desc.section3Title")}
          </MKTypography>
          <MKTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
            {t("clients.windows.desc.section3Body")}
          </MKTypography>
        </Grid>
      </Grid>
    </Card>
  );
}

export default WindowsDesc;
